export const ROUTES = {
    preview: "preview",
    padPreview: "padpreview",
    padCreation: "create-pad",
};
